// import { useNavigate } from "react-router-dom";
// import { useMemo, useState } from "react";
// import usePopup from "../../hooks/usePopup";
import {
  // useMutation,
  useQuery,
} from "react-query";
import {
  // getClinicData,
  getTableData,
  //  updateState
} from "./services";
// import { SettingsTableDataType, SearchParamsType } from "./types";
import {
  Divider,
  // Button,
  Paper,
  Typography,
} from "@mui/material";
// import moduleRoutes from "../../routes/moduleRouteList";
// import SettingsRouteList from "../routeList";
import useAuthentication from "@hooks/useAuthentication";
import AddOrEditClinic from "./AddOrEditClinic";
const pageTitle = "Clinic Settings";
// const base = (window as any)._env_?.BASE_URL;

const ClinicManagemant = () => {
  // const navigate = useNavigate();
  // const [searchParams, setSearchParams] = useState<SearchParamsType>({
  //   filter: { searchText: "", status: 2 },
  //   pageNumber: 0,
  //   pageSize: 25,
  //   sortField: "",
  //   sortOrder: "",
  // });
  const { user } = useAuthentication();
  // const [open, setOpen] = useState<boolean>(false);
  // const { CustomModal, showSnackbar } = usePopup();
  // const [changedStatus, setChangedStatus] = useState<number>(2);
  // const [selected, setSelected] = useState<{
  //   [key: number]: SettingsTableDataType;
  // }>({});
  // const [selectedId, setSelectedId] = useState<number | null>(null);

  const {
    data: settingsData,
    // isFetching: settingsDataLoading,
    // refetch: refetchSettingsData,
  } = useQuery(
    ["clinicManagementFullData", user?.clinicId],
    async () => await getTableData(Number(user?.tenantClinicId || 0)),
    {
      refetchOnWindowFocus: false,
      enabled: true,
    },
  );

  // const {
  //   data: tableData,
  //   isFetching: tableDataLoading,
  //   refetch,
  // } = useQuery(
  //   ["clinicManagementData", user?.clinicId],async () => await getClinicData(user?.clinicId),
  //   {
  //     refetchOnWindowFocus: false,
  //     enabled: true,
  //   }
  // );

  // const { mutate: updateStatus, isLoading } = useMutation(updateState, {
  //   onSuccess: (result) => {
  //     if (result.responseIndicator == "success") {
  //       // refetch();
  //       setSelected({});
  //       setOpen(false);
  //       setChangedStatus(2);
  //       // setSelectedId(null);
  //       showSnackbar({
  //         message: result.responseMessage,
  //         open: true,
  //         variant: "success",
  //         duration: 3000,
  //       });
  //     } else {
  //       showSnackbar({
  //         message: result.responseMessage,
  //         open: true,
  //         variant: "warning",
  //         duration: 3000,
  //       });
  //     }
  //   },
  //   onError: (e: any) => {
  //     showSnackbar({
  //       message: e?.response?.data?.responseMessage || "Something went wrong !",
  //       open: true,
  //       variant: "error",
  //       duration: 3000,
  //     });
  //   },
  // });

  // const handleChangePage = (
  //   _: React.MouseEvent<HTMLButtonElement> | null,
  //   pageNumber: number
  // ) => {
  //   setSearchParams((prev) => ({
  //     ...prev,
  //     pageNumber,
  //   }));
  // };

  // const handleChangeRowsPerPage = (
  //   event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   setSearchParams((prev) => ({
  //     ...prev,
  //     pageNumber: 0,
  //     pageSize: parseInt(event.target.value, 10),
  //   }));
  // };

  // const handleStatusChange = (
  //   _: SyntheticEvent,
  //   value: { label: string; value: number } | null
  // ) => {
  //   setSearchParams((prev) => ({
  //     ...prev,
  //     status: value ? value.value : 2,
  //     filter: { ...prev.filter, status: value ? value.value : 2 },
  //   }));
  // };

  // const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   setSearchParams((prev) => ({
  //     ...prev,
  //     filter: { ...prev.filter, searchText: e.target.value },
  //   }));
  // };

  // const debounceSearch = debounce(handleSearchChange, 500);

  // const handleNavigateClick = (data?: SettingsTableDataType) => {
  //   navigate(
  //     `${base}${moduleRoutes.mainRoute}/${moduleRoutes.settings}/${SettingsRouteList.clinicManagement}/${SettingsRouteList.addOrEdit}`,
  //     { state: { data: data || null } }
  //   );
  // };

  // const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.checked) {
  //     const objs: { [key: number]: SettingsTableDataType } = {};
  //     tableData?.response?.clinics?.map(
  //       (item: SettingsTableDataType, index: number) => {
  //         objs[index] = item as SettingsTableDataType;
  //       }
  //     );
  //     setSelected(objs);
  //   } else {
  //     setSelected({});
  //   }
  // };

  // const handleSelect = (
  //   isChecked: boolean,
  //   item: SettingsTableDataType,
  //   index: number
  // ) => {
  //   if (isChecked) {
  //     setSelected((prev) => ({
  //       ...prev,
  //       [index]: item,
  //     }));
  //   } else {
  //     setSelected((prev) => {
  //       const newSelected = { ...prev };
  //       delete newSelected[index];
  //       return newSelected;
  //     });
  //   }
  // };
  // const handleOpenChangeStatus = () => {
  //   setOpen(true);
  // };

  // const handleCloseChangeStatus = () => {
  //   setOpen(false);
  // };

  // const handleUpdateStatus = () => {
  //   if (changedStatus == 2) {
  //     showSnackbar({
  //       message: "Please select a status !",
  //       open: true,
  //       variant: "warning",
  //       duration: 3000,
  //     });
  //   } else {
  //     const items: {
  //       status: number;
  //       clinicId: number;
  //     }[] = [];
  //     for (let key in selected) {
  //       items.push({
  //         clinicId: selected[key].clinicId,
  //         status: changedStatus,
  //       });
  //     }
  //     updateStatus(items);
  //     // console.log(selected)
  //   }
  // };

  // const handleUpdateOneStatus = (
  //   status: boolean,
  //   data: SettingsTableDataType
  // ) => {
  //   setSelectedId(data.clinicId);
  //   updateStatus([
  //     {
  //       clinicId: data.clinicId,
  //       status: status ? 1 : 0,
  //     },
  //   ]);
  // };

  // const selectedSize = useMemo(() => {
  //   return Object.keys(selected).length;
  // }, [selected]);
  return (
    <div className="p-3">
      {/* <CustomModal
        open={open || (isLoading && Boolean(selectedSize))}
        setOpen={setOpen}
        title={`Change status`}
        handleClose={handleCloseChangeStatus}
      >
        <div className="w-[50vw]">
          <div className="max-h-[65vh] overflow-y-auto">
            {Object.entries(selected).map(([key, item], index) => (
              <div
                key={`${index + key}`}
                className="flex gap-2 ps-3 justify-start items-center py-2 overflow-y-auto"
              >
                <div className="h-[7px] w-[7px] bg-green-600 rounded m-2"></div>{" "}
                <div>{item?.domainName}</div>
              </div>
            ))}
          </div>
          <Divider />
          <div className="flex justify-end items-center gap-2 p-3">
            <Autocomplete
              disableClearable
              sx={{ width: "200px" }}
              options={status}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              renderInput={(params) => <TextField {...params} label="Status" />}
              onChange={(_, value) => {
                setChangedStatus(value?.value);
              }}
            />
            <Button
              disabled={isLoading}
              endIcon={
                isLoading && <CircularProgress size={20} color="success" />
              }
              color="success"
              onClick={handleUpdateStatus}
            >
              Update
            </Button>
          </div>
        </div>
      </CustomModal> */}
      <Paper>
        <div className="flex justify-between p-3">
          <div className="flex gap-2">
            <Typography variant="h6" color={"default"}>
              {pageTitle}
            </Typography>
          </div>
          <div className="flex gap-2">
            {/* <Button
              onClick={() => {
                handleNavigateClick();
              }}
            >
              new {pageTitle}
            </Button> */}
          </div>
        </div>
        <Divider />
        <AddOrEditClinic data={settingsData?.response || null} />
      </Paper>
    </div>
  );
};

export default ClinicManagemant;

// const headings = [
//   {
//     label: "Title",
//     key: "icdCode",
//   },
//   {
//     label: "Address",
//     key: "icdName",
//   },
//   {
//     label: "Logo",
//     key: "icdVersion",
//   },
//   {
//     label: "Remarks",
//     key: "icdVersion",
//   },
// ];
// const statusOptions = [
//   { label: "All", value: 2 },
//   { label: "Active", value: 1 },
//   { label: "Inactive", value: 0 },
// ];
// const status = [
//   { label: "Active", value: 1 },
//   { label: "Inactive", value: 0 },
// ];
// const selectedStatus = {
//   2: { label: "All", value: 2 },
//   1: { label: "Active", value: 1 },
//   0: { label: "Inactive", value: 0 },
// };
